(function() { window.GUID_f6d7fef5_6a91_430a_94d7_c37e1a7f69ee = { getGuid: function() { return "f6d7fef5-6a91-430a-94d7-c37e1a7f69ee"; } }; })();


//# sourceMappingURL=IHasChanged.js.map
